export interface AppConfig {
  transportMode: "proxy" | "direct";
  containerUrl: string;
  prefix: string;
  /** Only populated in direct mode, where the browser talks to blob storage itself. */
  sasQuery: string | null;
}

let cached: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  const res = await fetch("/api/config");
  if (!res.ok) throw new Error(`Sunucu yapılandırması alınamadı (HTTP ${res.status}).`);
  cached = (await res.json()) as AppConfig;
  return cached;
}
